export default function Footer() {
  return (
    <footer className="w-full bg-white border-t border-[#E6EDEB]">
      <div className="flex flex-col-reverse md:flex-row items-center md:justify-between gap-4 px-6 md:px-12 lg:px-30 py-8">
        <p className="md:text-sm text-xs text-[#9196A3] font-normal text-center">
          © 2026 360Service. All rights reserved.
        </p>

        <div className="flex items-center gap-4">
          <a
            href="#"
            className="md:text-sm text-xs text-[#9196A3] hover:text-[#0064E0] transition-colors"
          >
            Privacy Policy
          </a>
          <span className="size-1 rounded-full bg-[#9196A3]"></span>
          <a
            href="#"
            className="md:text-sm text-xs text-[#9196A3] hover:text-[#0064E0] transition-colors"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}
